<template>
  <v-container fluid class="pa-0">
    <!--TOOLBAR-->
    <v-app-bar flat color="red-darken-3">
      <v-app-bar-title class="hidden-sm-and-down">
        {{ $t("warranties.label") }}
      </v-app-bar-title>
      <v-divider class="mx-5 hidden-sm-and-down" inset vertical />
      <v-text-field
        v-model="search"
        :label="$t('warranties.search')"
        flat
        variant="solo"
        color="red-darken-1"
        append-inner-icon="mdi-magnify"
        single-line
        class="mx-1"
        hide-details
      />
      <v-spacer class="hidden-sm-and-down" />

      <v-btn
        v-if="
          $store.getters.role == 'LekoAdmin' ||
          $store.getters.role == 'LekoEmployee' ||
          $store.getters.role == 'InstitutionAdmin' ||
          $store.getters.role == 'SuperAdmin'
        "
        color="grey-darken-4"
        variant="flat"
        @click="newWarranty"
      >
        {{ $t("warranties.button") }}
        <v-icon end>mdi-plus</v-icon>
      </v-btn>
    </v-app-bar>

    <!--ALERT-->
    <v-alert :model-value="alert.value" type="error">
      {{ alert.message }}
    </v-alert>

    <!--DIALOG-->
    <edit-dialog ref="editDialog" @close="getWarranties" @error="error" />
    <!--DATATABLE-->
    <datatable
      ref="datatable"
      :search="search"
      @edit="editWarranty"
      @error="error"
    />
  </v-container>
</template>

<script>
import Datatable from "@/components/Warranties/datatable.vue";
import EditDialog from "@/components/Warranties/dialog.vue";

export default {
  components: {
    datatable: Datatable,
    "edit-dialog": EditDialog,
  },
  data: () => ({
    search: "",
    alert: { value: false, message: "" },
  }),
  watch: {
    search(value) {
      const { datatable } = this.$refs;
      datatable.search(value);
    },
  },
  methods: {
    newWarranty() {
      const { editDialog } = this.$refs;
      editDialog.open(false, null);
    },
    editWarranty(data) {
      const { editDialog } = this.$refs;
      editDialog.open(true, data);
    },
    getWarranties() {
      const { datatable } = this.$refs;
      datatable.getWarranties();
    },
    error() {
      this.alert = { value: true, message: "" };
      setTimeout(() => {
        this.alert = { value: false, message: "" };
      }, 2000);
    },
  },
};
</script>
